
      import UserLeave from './user-leave.vue'
      import type { App, Plugin } from 'vue'

      export const UserLeavePlugin: Plugin = {
        install(app: App) {
          app.component('UserLeave', UserLeave)
        },
      }
      export { UserLeave }
      